import { Bot } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'agent',
    title: 'Agent',
    icon: Bot,
    // Mirror camera_settings / rule_editor — wide enough for a label rail +
    // form column once a single agent is selected.
    width: { min: 384, default: 480, max: 768, fill: false },
    modes: [PanelMode.Settings],
    themes: PanelTheme.Any,
    // The form is the user's primary surface in settings mode — keep it on
    // screen at narrow widths the same way camera_settings does.
    order: 4,
    // Host owns the header + footer.
    isHeaderless: true,
    // Mutual exclusions live in src/app/exclusions.ts (settings-detail clique
    // plus the agent-vs-other-lists overrides).
    // agentId lives in this panel's local props in localStorage (not URL-synced —
    // shared links stay short and don't leak settings selections).
    urlSyncedProps: [],
    // Opened by the Agents list rather than a navigation button.
    hasNavButton: false,
    // The agent list of the analytics server, on its Agents tab, is the place that opens it.
    summoner: { id: 'servers', props: ['serverId', 'serverTab'] },
});
